export default function Datetime({
    date
}) {
    return (
        date ? new Intl.DateTimeFormat('es-CL', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(date)) : null
    )
}
